import { CALL_API } from '../middleware/ApiMiddleware';

export const CASE_CUSTOM_TILE_CREATE_REQUEST = 'CASE_CUSTOM_TILE_CREATE_REQUEST';
export const CASE_CUSTOM_TILE_CREATE_SUCCESS = 'CASE_CUSTOM_TILE_CREATE_SUCCESS';
export const CASE_CUSTOM_TILE_CREATE_FAILURE = 'CASE_CUSTOM_TILE_CREATE_FAILURE';

export const CASE_CUSTOM_TILE_EDIT_REQUEST = 'CASE_CUSTOM_TILE_EDIT_REQUEST';
export const CASE_CUSTOM_TILE_EDIT_SUCCESS = 'CASE_CUSTOM_TILE_EDIT_SUCCESS';
export const CASE_CUSTOM_TILE_EDIT_FAILURE = 'CASE_CUSTOM_TILE_EDIT_FAILURE';

export const CASE_CUSTOM_TILE_FETCH_REQUEST = 'CASE_CUSTOM_TILE_FETCH_REQUEST';
export const CASE_CUSTOM_TILE_FETCH_SUCCESS = 'CASE_CUSTOM_TILE_FETCH_SUCCESS';
export const CASE_CUSTOM_TILE_FETCH_FAILURE = 'CASE_CUSTOM_TILE_FETCH_FAILURE';

const baseURL = 'xerce/config/case-custom-tiles';

export const createCaseCustomTile = (caseCustomTile: IConfigCaseCustomTileRequest) => ({
  [CALL_API]: {
    endpoint: baseURL,
    method: 'post',
    body: caseCustomTile,
    authenticated: true,
    types: [CASE_CUSTOM_TILE_CREATE_REQUEST, CASE_CUSTOM_TILE_CREATE_SUCCESS, CASE_CUSTOM_TILE_CREATE_FAILURE],
  },
});

export const editCaseCustomTile = (
  caseCustomTileId: number,
  caseCustomTileEditRequest: IConfigCaseCustomTileEditRequest
) => ({
  [CALL_API]: {
    endpoint: `${baseURL}/${caseCustomTileId}`,
    method: 'put',
    body: caseCustomTileEditRequest,
    authenticated: true,
    types: [CASE_CUSTOM_TILE_EDIT_REQUEST, CASE_CUSTOM_TILE_EDIT_SUCCESS, CASE_CUSTOM_TILE_EDIT_FAILURE],
  },
});

export const fetchCaseCustomTile = (caseCustomTileId: number) => ({
  [CALL_API]: {
    endpoint: `${baseURL}/${caseCustomTileId}`,
    method: 'get',
    authenticated: true,
    types: [CASE_CUSTOM_TILE_FETCH_REQUEST, CASE_CUSTOM_TILE_FETCH_SUCCESS, CASE_CUSTOM_TILE_FETCH_FAILURE],
  },
});
